var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { border: "1px solid #ccc", "min-width": "700px" } },
      [
        _c("Toolbar", {
          staticStyle: { "border-bottom": "1px solid #ccc" },
          attrs: {
            editor: _vm.editor,
            defaultConfig: _vm.toolbarConfig,
            mode: _vm.mode,
          },
        }),
        _c("Editor", {
          style: {
            height: _vm.height + "px",
            width: _vm.width + "px",
          },
          attrs: {
            id: "editor-" + _vm.idNum,
            defaultConfig: _vm.editorConfig,
            mode: _vm.mode,
          },
          on: { onCreated: _vm.onCreated, onChange: _vm.onChange },
          model: {
            value: _vm.sendData,
            callback: function ($$v) {
              _vm.sendData = $$v
            },
            expression: "sendData",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }